<div class="tcf-warning">
  <div class="tcf-warning__body">
    <div class="tcf-warning__notice">
      TCF applies only to EEA countries. If you target traffic outside the EEA,
      enabling "Only with consent" filter may reduce your traffic volume.
    </div>

    <div class="tcf-countries-list" (click)="onShowCountriesList()">
      View the list of countries
    </div>

    <div class="countries-list-wrap" *ngIf="isShowCountriesList">
      <div class="countries-list-item" *ngFor="let country of countriesList">
        <div class="countries-list-item-name">
          {{ country.name }}
        </div>
      </div>
    </div>

    <div class="tcf-warning-text">
      Are you sure you want to activate this filter?
    </div>
  </div>

  <div class="tcf-warning__footer">
    <button
      nz-button
      type="button"
      nzType="primary"
      class="tcf-warning__btn"
      (click)="onConfirm()"
    >
      Yes, activate
    </button>
    <button
      nz-button
      type="button"
      nzType="default"
      class="tcf-warning__btn"
      (click)="onCloseModal()"
    >
      No, cancel
    </button>
  </div>
</div>
